/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Monitor_Desc7Inputs */

const en_svc_retainer_monitor_desc7 = /** @type {(inputs: Svc_Retainer_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errors and downtime caught by Sentry and uptime checks, not by your users.`)
};

const ar_svc_retainer_monitor_desc7 = /** @type {(inputs: Svc_Retainer_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأخطاء والتوقف يلتقطها Sentry وفحوص التوافر، لا مستخدموك.`)
};

const bn_svc_retainer_monitor_desc7 = /** @type {(inputs: Svc_Retainer_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এরর আর ডাউনটাইম Sentry আর আপটাইম চেক ধরে, আপনার ব্যবহারকারীরা নয়।`)
};

const de_svc_retainer_monitor_desc7 = /** @type {(inputs: Svc_Retainer_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler und Ausfallzeiten werden von Sentry und Uptime-Checks gefangen, nicht von Ihren Nutzern.`)
};

const es_svc_retainer_monitor_desc7 = /** @type {(inputs: Svc_Retainer_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errores y caídas detectados por Sentry y controles de disponibilidad, no por sus usuarios.`)
};

const fr_svc_retainer_monitor_desc7 = /** @type {(inputs: Svc_Retainer_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreurs et pannes captées par Sentry et les contrôles de disponibilité, pas par vos utilisateurs.`)
};

const pt_svc_retainer_monitor_desc7 = /** @type {(inputs: Svc_Retainer_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erros e quebras detetados por Sentry e controlos de disponibilidade, não pelos seus utilizadores.`)
};

const zh_svc_retainer_monitor_desc7 = /** @type {(inputs: Svc_Retainer_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报错和宕机由 Sentry 和可用性检查先发现，不是你的用户先发现。`)
};

const tr_svc_retainer_monitor_desc7 = /** @type {(inputs: Svc_Retainer_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hata ve kesintiler Sentry ve erişim kontrolleriyle yakalanır, kullanıcılarınızla değil.`)
};

const ru_svc_retainer_monitor_desc7 = /** @type {(inputs: Svc_Retainer_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибки и даунтайм ловят Sentry и аптайм-чеки, а не ваши пользователи.`)
};

const pl_svc_retainer_monitor_desc7 = /** @type {(inputs: Svc_Retainer_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błędy i przestoje łapią Sentry i kontrole dostępności, nie użytkownicy.`)
};

/**
* | output |
* | --- |
* | "Errors and downtime caught by Sentry and uptime checks, not by your users." |
*
* @param {Svc_Retainer_Monitor_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_monitor_desc7 = /** @type {((inputs?: Svc_Retainer_Monitor_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Monitor_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_monitor_desc7(inputs)
	if (locale === "bn") return bn_svc_retainer_monitor_desc7(inputs)
	if (locale === "de") return de_svc_retainer_monitor_desc7(inputs)
	if (locale === "es") return es_svc_retainer_monitor_desc7(inputs)
	if (locale === "fr") return fr_svc_retainer_monitor_desc7(inputs)
	if (locale === "pt") return pt_svc_retainer_monitor_desc7(inputs)
	if (locale === "zh") return zh_svc_retainer_monitor_desc7(inputs)
	if (locale === "tr") return tr_svc_retainer_monitor_desc7(inputs)
	if (locale === "ru") return ru_svc_retainer_monitor_desc7(inputs)
	if (locale === "pl") return pl_svc_retainer_monitor_desc7(inputs)
	return en_svc_retainer_monitor_desc7(inputs)
});
export { svc_retainer_monitor_desc7 as "svc_retainer_MONITOR_desc" }